import { useMemo } from 'react';
import { Allocation, UserRegistrationPeriod } from '../api/generated/data-contracts';
import { calculateMissingAllocatedList } from '../helpers/calculateMissingHoursAllocatedList';
import { PeriodDay } from '../types/PeriodDay';
import { useAllocationFormatter } from '../hooks/useAllocationFormatter';

export const ListMissingAllocations = ({
    projects,
    allocations,
    perioddays,
}: {
    projects: UserRegistrationPeriod[];
    allocations: Allocation[];
    perioddays: PeriodDay[];
}) => {
    // if missing hours on a project, add them to a list with project names and missing hours
    const missingHoursList = useMemo(() => calculateMissingAllocatedList(projects, allocations), [projects, allocations]);
    const formatAllocation = useAllocationFormatter(perioddays);

    const renderProjectName = (projectName: string) => {
        return projectName.length > 28 ? `${projectName.substring(0, 28)}...` : projectName;
    };

    if (missingHoursList.length > 0) {
        return (
            <div>
                <h4>Allocations</h4>
                <p>You have registered less hours than allocated on the following projects:</p>
                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 10px' }}>
                    <thead>
                        <tr>
                            <th style={{ textAlign: 'left', padding: '10px' }}>Project</th>
                            <th style={{ textAlign: 'left', padding: '10px' }}>Allocated</th>
                            <th style={{ textAlign: 'left', padding: '10px' }}>Registered</th>
                            <th style={{ textAlign: 'left', padding: '10px' }}>Below</th>
                        </tr>
                    </thead>
                    <tbody>
                        {missingHoursList.map(missing => (
                            <tr key={missing.projectName} style={{ marginBottom: '10px' }}>
                                <td style={{ padding: '10px' }} title={missing.projectName}>
                                    {renderProjectName(missing.projectName)}
                                </td>
                                <td style={{ padding: '10px' }}>{formatAllocation(missing.allocatedHours)}</td>
                                <td style={{ padding: '10px' }}>{formatAllocation(missing.registeredHours)}</td>
                                <td style={{ padding: '10px' }}>{formatAllocation(missing.missingHours)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>Are you sure you want to proceed?</p>
            </div>
        );
    }

    return <></>;
};
